var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsCountryCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4295_19246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9995C18.6271 23.9995 23.9998 18.6264 23.9998 11.9998C23.9998 5.37318 18.6275 0 12 0C5.37248 0 0.000244141 5.37364 0.000244141 11.9998C0.000244141 18.6259 5.37295 23.9995 12 23.9995Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2264 5.7351H11.4604V2.60156H19.4599C20.5584 3.4761 21.4948 4.53671 22.2264 5.7351ZM23.9997 12.0008H11.467V8.86816H23.5867C23.8617 9.88962 24.0005 10.9429 23.9997 12.0008ZM11.9999 24.0005C14.7128 24.0068 17.3467 23.0874 19.4665 21.3943H4.53381C6.65324 23.0877 9.28708 24.0071 11.9999 24.0005ZM22.2396 18.2678H1.76027C1.16295 17.2937 0.709378 16.2385 0.413574 15.1348H23.5862C23.2905 16.2385 22.837 17.2937 22.2396 18.2678Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57123 1.86747H5.56045V1.87497L5.57123 1.86747ZM5.57123 1.86747H6.65636L5.63404 2.60105L6.02075 3.80103L5.00077 3.06745L3.98735 3.80103L4.32063 2.76558C3.42491 3.51526 2.6434 4.39167 2.00083 5.36709H2.35426L1.7074 5.83583L1.41397 6.35145L1.72052 7.30487L1.14069 6.883L0.740855 7.81392L1.07413 8.85921H2.33973L1.33381 9.60029L1.72052 10.8003L0.700543 10.0667L0.100555 10.5064C0.0336014 11.0014 8.85596e-05 11.5003 0.000244684 11.9998H12V1.01072e-05C9.72289 -0.00295146 7.49237 0.644983 5.57123 1.86747ZM6.01841 10.7942L6.02731 10.8012H6.02075L6.01841 10.7942ZM5.63357 9.60076L6.01841 10.7942L5.0003 10.0676L3.98032 10.8012L4.36703 9.60123L3.34705 8.86765H4.61265L4.99937 7.66767L5.38608 8.86765H6.65168L5.63357 9.60076ZM5.6406 6.1077L6.02731 7.30768L5.00733 6.5741L3.98735 7.30768L4.37407 6.1077L3.35409 5.37412H4.61969L5.0064 4.17415L5.39311 5.37412H6.65871L5.6406 6.1077ZM9.31366 10.0676L10.3336 10.8012L9.94693 9.60123L10.9688 8.86765H9.70318L9.31647 7.66767L8.92976 8.86765H7.66416L8.68414 9.60123L8.29743 10.8012L9.31366 10.0676ZM9.94693 6.1077L10.3336 7.30768L9.31366 6.5741L8.29368 7.30768L8.68039 6.1077L7.66041 5.37412H8.92601L9.31272 4.17415L9.69943 5.37412H10.965L9.94693 6.1077ZM10.3336 3.81415L9.94693 2.61418L10.9688 1.8806H9.70318L9.31647 0.680622L8.92976 1.8806H7.66416L8.68414 2.61418L8.29743 3.81415L9.31741 3.08057L10.3336 3.81415Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4295_19246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsCountryCode);
export default __webpack_public_path__ + "static/media/US_countryCode.e8bb333646c515cfd751bad79954d94b.svg";
export { ForwardRef as ReactComponent };